module.exports = __webpack_public_path__ + "media/video.8611cd95.mp4";